import React, { useMemo } from 'react'
import { Box, Container, Typography } from '@mui/material'
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined'
import ActionTile, { ActionTileProps } from '@zuto/atoms/src/Mui/Tile/ActionTile'
import { formlessColors } from '@zuto/theme/src/mui/Colors'
import { ContactVariables } from '../../../../../GlobalVariables/Contact'
import EventsService, { AppFormCustomEventType, AppFormEventParams } from '../../../../../services/events-service'

const PHONE_LINK = `tel:${ContactVariables.zutoContactNumber}`
const WHATSAPP_LINK = `https://wa.me/${ContactVariables.whatsappNumber}`
const SMS_LINK = `sms:${ContactVariables.zutoContactNumber}`

type ContactTile = ActionTileProps & { eventType: AppFormCustomEventType }

const contactTiles: ContactTile[] = [
  {
    label: 'Phone',
    icon: PhoneInTalkOutlinedIcon,
    href: PHONE_LINK,
    bgColor: formlessColors.surfaceBlueSoft,
    iconColor: formlessColors.iconBlue,
    eventType: 'PhoneCta'
  },
  {
    label: 'WhatsApp',
    icon: WhatsAppIcon,
    href: WHATSAPP_LINK,
    bgColor: formlessColors.surfaceGreenSoft,
    iconColor: formlessColors.iconGreen,
    target: '_blank',
    rel: 'noopener noreferrer',
    eventType: 'WhatsappCta'
  },
  {
    label: 'SMS',
    icon: SmsOutlinedIcon,
    href: SMS_LINK,
    bgColor: formlessColors.surfaceSkySoft,
    iconColor: formlessColors.iconSky,
    eventType: 'SmsCta'
  }
]

interface ContactOptionsProps {
  eventsServiceUrl: string
  appFormEventParams?: AppFormEventParams
}

const ContactOptions: React.FC<ContactOptionsProps> = ({ eventsServiceUrl, appFormEventParams }) => {
  const eventsService = useMemo(() => (appFormEventParams ? EventsService(eventsServiceUrl, appFormEventParams) : undefined), [eventsServiceUrl, appFormEventParams])

  return (
    <Container
      sx={{
        margin: '0 auto 40px',
        px: { xs: 6 },
        py: 5,
        borderRadius: '16px',
        border: 1,
        borderColor: formlessColors.borderSubtle,
        backgroundColor: 'background.paper',
        textAlign: 'center',
        boxShadow: '0 8px 20px rgba(15,23,42,0.04)',
        boxSizing: 'border-box',
        mx: { xs: 5, md: 'auto' },
        width: { xs: 'unset', md: '100%' }
      }}
      maxWidth="md"
    >
      <Typography
        sx={{ fontWeight: 600, marginBottom: 5 }}
        variant="bodyLarge"
        component="p"
      >
        Need anything before we call? Contact us on
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', boxSizing: 'border-box' }}>
        {contactTiles.map((tile, index) => (
          <Box
            key={tile.label}
            sx={{
              width: { xs: '50%', sm: '25%' },
              mb: index < contactTiles.length - 2 ? 5 : { xs: 5, sm: 0 },
              px: '6px',
              boxSizing: 'border-box'
            }}
          >
            <ActionTile
              {...tile}
              onClick={() => {
                if (eventsService) {
                  eventsService.sendEvent(tile.eventType)
                }
              }}
            />
          </Box>
        ))}
      </Box>
    </Container>
  )
}

export default ContactOptions
